import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="code-generator"
//
// Pulls a code (UPC for an album, ISRC for a track) out of its bank and drops
// it into the field. The link removes itself once a code has been handed out -
// a record consumes exactly one.
export default class extends Controller {
  static targets = ["input", "link", "error"]
  static values = { url: String }

  async generate() {
    this.linkTarget.disabled = true
    const originalText = this.linkTarget.textContent
    this.linkTarget.textContent = this.linkTarget.dataset.generatingText

    this.hideError()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.inputTarget.value = data.code
        this.linkTarget.remove()
      } else {
        this.showError(data.error)
        this.linkTarget.disabled = false
        this.linkTarget.textContent = originalText
      }
    } catch (error) {
      this.showError(this.linkTarget.dataset.errorText)
      this.linkTarget.disabled = false
      this.linkTarget.textContent = originalText
    }
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
